export { Checkbox as default } from './Checkbox';
export { checkboxClasses } from '@mui/joy/Checkbox';
export type { CheckboxProps } from '@mui/joy/Checkbox';
